export default class OrderForm {
    constructor(form_id, item_id, item_count, item_index = 0) {
        this.form_id = form_id;
        this.item_id = item_id;
        this.item_count = item_count;
        this.item_index = item_index;

        this.unique_item_id = this.item_id + '-' + this.item_count + '-' + this.item_index;
        
        this.fields = window.theme.order_forms[this.form_id]?.fields;
        this.field_elements = [];
        this.form_data = [];
    }

    get_field(field_key) {
        let return_field = null;
        this.fields.forEach((field) => {
            if(field.key == field_key) {
                return_field = field;
            }
        });

        return return_field;
    }

    render() {
        let return_element = document.createElement('div');

        return_element.classList.add('order-form');

        if(this.fields.length == 1) {
            return_element.classList.add('--single');
        }

        this.fields.forEach((field) => {
            let field_element = document.createElement('div');
            let label_element = document.createElement('label');
            let error_info = document.createElement('p');

            error_info.classList.add('order-form__field__error-label');

            field_element.classList.add('order-form__field', `--${field.width}`);

            if(field.required) {
                field_element.required = true;
            }

            field.id = field.key + '-' + this.unique_item_id;

            label_element.innerText = field.label;
            label_element.setAttribute('for', field.id);
            label_element.classList.add('order-form__field__label');

            if(field.type == 'text') {                
                field_element.appendChild(label_element);
                field_element.appendChild(this.makeText(field, label_element, error_info));
            } else if(field.type == 'radio') {
                field_element.appendChild(label_element);
                field_element.appendChild(this.makeRadio(field, label_element, error_info));
            }

            field_element.appendChild(error_info);

            return_element.appendChild(field_element);
        });

        this.updateData();

        return return_element;
    }

    validate() {
        this.field_elements.forEach((field_element) => {
            field_element.dispatchEvent(new Event('validate'));

            field_element.querySelectorAll('input').forEach((input) => {
                input.dispatchEvent(new Event('validate'));
            });
        });
    }

    updateData() {
        this.form_data = [];

        this.field_elements.forEach((field_element) => {
            let field_config = this.get_field(field_element.dataset.key);

            this.form_data.push({
                id: field_element.id,
                title: field_config.admin_label,
                value: field_element.value,
                error: (field_config.required == true && !field_element.value ? true : false)
            });
        });

        let item_data = window.theme.cart.getItemData(this.item_id);

        if(!item_data) {
            item_data = {};
        }

        if(!item_data.form_data) {
            item_data.form_data = {};
        }

        if(!item_data.form_data[this.item_id + '-' + this.item_count]) {
            item_data.form_data[this.item_id + '-' + this.item_count] = {};
        }

        item_data.form_data[this.item_id + '-' + this.item_count][this.unique_item_id] = this.form_data;

        window.theme.cart.updateItemData(this.item_id, item_data);
    }

    getExistingValue(field_id) {
        let return_value = null;
        let item_data = window.theme.cart.getItemData(this.item_id);

        if(item_data && item_data.form_data && item_data.form_data[this.item_id + '-' + this.item_count] && item_data.form_data[this.item_id + '-' + this.item_count][this.unique_item_id]) {
            item_data.form_data[this.item_id + '-' + this.item_count][this.unique_item_id].forEach((field) => {
                if(field.id == field_id) {
                    return_value = field['value'];
                }
            });
        }

        return return_value;
    }

    makeText(field, label, error) {
        let text_field = document.createElement('input');

        text_field.id = field.id;
        text_field.dataset.key = field.key;
        text_field.name = field.key;
        text_field.type = 'text';
        text_field.placeholder = field.placeholder ?? null;
        text_field.value = field.default_value ?? null;
        text_field.classList.add('order-form__field__input', '--text');

        let existingValue = this.getExistingValue(text_field.id);

        if(existingValue) {
            text_field.value = existingValue;
        }

        text_field.addEventListener('change', (event) => {
            //trim & clean results
            text_field.value = text_field.value.replace(/\s+/g, ' ').trim();

            //title case results (if applicable)
            if(field.title_case == true) {
                text_field.value = this.titleCase(text_field.value);
            }

            this.updateData();
        });

        text_field.addEventListener('validate', (event) => {
            if(!text_field.value && field.required) {
                text_field.classList.add('--error');
                label.classList.add('--error');
                error.innerText = 'This is a required field';
                text_field.dataset.hasErrors = true;
            } else {
                text_field.classList.remove('--error');
                label.classList.remove('--error');
                text_field.dataset.hasErrors = false;
            }
        });

        this.field_elements.push(text_field);

        return text_field;
    }

    makeRadio(field, label, error) {
        let fieldset_field = document.createElement('fieldset');

        fieldset_field.classList.add('order-form__field__fieldset');
        fieldset_field.dataset.key = field.key;
        fieldset_field.id = field.id;

        let existingValue = this.getExistingValue(field.id);

        if(!existingValue) {
            existingValue = field.default_value;
        }

        fieldset_field.value = existingValue;

        field.options.forEach((option, index) => {
            let radio_container = document.createElement('div');

            radio_container.classList.add('order-form__field__fieldset__item');

            let radio_field = document.createElement('input');

            radio_field.name = field.key + '-' + field.id + '-' + this.item_count + '-' + this.item_index;
            radio_field.type = 'radio';
            radio_field.id = field.id + '-' + index;
            radio_field.classList.add('order-form__field__input', '--radio');

            if(option.value) {
                radio_field.dataset.value = option.value;
            } else {
                radio_field.dataset.value = option.label;
            }

            if(radio_field.dataset.value == existingValue) {
                radio_field.checked = true;
            } else if(field.default_value == radio_field.dataset.value && !existingValue) {
                radio_field.checked = true;
            }

            radio_field.addEventListener('input', (event) => {
                radio_field.parentElement.parentElement.value = radio_field.dataset.value;

                // if(radio_field.checked == true) {
                //     radio_field.checked = false;
                //     radio_field.parentElement.parentElement.value = '';
                // }

                this.updateData();
            });

            radio_field.addEventListener('validate', (event) => {
                if(!radio_field.parentElement.parentElement.value && field.required) {
                    label_field.classList.add('--error');
                    label_field.parentElement.parentElement.classList.add('--error');
                    fieldset_field.dataset.hasErrors = true;
                    error.innerText = 'This is a required field';
                } else {
                    label_field.classList.remove('--error');
                    label_field.parentElement.parentElement.classList.remove('--error');
                    fieldset_field.dataset.hasErrors = false;
                }
            });

            let label_field = document.createElement('label');

            label_field.innerText = option.label;
            label_field.setAttribute('for', radio_field.id);
            label_field.classList.add('order-form__field__fieldset__label');

            radio_container.appendChild(radio_field);
            radio_container.appendChild(label_field);

            fieldset_field.appendChild(radio_container);
        });

        this.field_elements.push(fieldset_field);

        return fieldset_field;
    }

    titleCase(str) {
        return str.replace(
            /\w\S*/g,
            function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }
        );
    }
}
